import { render } from "./UserTerms.vue?vue&type=template&id=4b0e3c77&scoped=true"
import script from "./UserTerms.vue?vue&type=script&lang=js"
export * from "./UserTerms.vue?vue&type=script&lang=js"

import "./UserTerms.vue?vue&type=style&index=0&id=4b0e3c77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0e3c77"]])

export default __exports__